// src/MofaQR.js

import React, { useEffect, useState } from "react";
import { QRCode } from "react-qrcode-logo";

import logo from "./mofa.svg";
import "./mofa.css";
import axios from "axios";
import Loader from "../../Layout/Loader";

export default function MofaQR({ setChooseBox }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [qr, setQr] = useState();

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      const [filenameInput] = e.target;
      const isValid = await axios.post(
        process.env.REACT_APP_BACKEND + "/file/can-upload",
        { fileName: filenameInput.value }
      );
      console.log(isValid.data);
      setSuccess(isValid.data.message);
      setQr(process.env.REACT_APP_MOFA_PREFIX + filenameInput.value + ".pdf");
    } catch (error) {
      setError(error.response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      setSuccess("");
      setError("");
      setQr("");
    }
  }, [loading]);

  return (
    <>
      {loading && <Loader />}
      <div className="mofa-container-main">
        <h1>Welcome To Mofa QR Generator</h1>
        {qr && (
          <div className="qr-generate-box">
            <div className="mofa-qr">
              <QRCode
                size={170}
                value={qr}
                logoImage={logo}
                logoHeight={40}
                logoWidth={35}
                removeQrCodeBehindLogo={true}
                qrStyle="dots"
                eyeRadius={[
                  [0, 7, 0, 7],
                  [0, 7, 0, 7],
                  [0, 7, 0, 7],
                ]}
              />
            </div>
            <p>Ministry of Foreign Affairs, Pakistan</p>
            <b>{qr.split("hq12/")[1].split(".")[0]}</b>
          </div>
        )}

        {qr && (
          <button className="print-btn" onClick={() => window.print()}>
            Print
          </button>
        )}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="file"
            required
            placeholder="Please Enter Filename"
            title="Please Enter name like this 'HQ12345sham'"
          />
          <button type="submit">Generate QR</button>
        </form>
        {error && <p className="text-red-500 font-semibold">{error}</p>}
        {success && <p className="text-fuchsia-800 font-semibold">{success}</p>}
        <button className="done-button" onClick={() => setChooseBox("")}>
          Done
        </button>
      </div>
    </>
  );
}
